import React from 'react';
import { Outlet } from 'react-router-dom';

const ReligiousRouter: React.FC = () => {
  return <Outlet />;
};

export default ReligiousRouter;
